<template>
  <div>
    <div class="list-area">
      <el-row :gutter="6">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="handleOperate('create')"
          >添加</el-button
        >
      </el-row>
      <el-row :gutter="6">
        <el-col :span="4">
          <el-input placeholder="请输入扣款流水号" v-model="searchData.id">
          </el-input>
        </el-col>
        <el-col :span="3">
          <el-select
            clearable
            v-model="searchData.companyName"
            filterable
            placeholder="请选择公司名称"
            @change="changeNameGetapp"
          >
            <el-option
              v-for="item in CompanyNameList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select
            clearable
            v-model="searchData.appName"
            filterable
            placeholder="请选择应用名称"
          >
            <el-option
              v-for="item in appList"
              :key="item.appId"
              :label="item.appName"
              :value="item.appId"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select
            clearable
            v-model="searchData.settlementModel"
            filterable
            placeholder="请选择结算模式"
          >
            <el-option
              v-for="(item, index) in settlementModellist"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select
            style="width: 100%"
            clearable
            filterable
            v-model="searchData.status"
            placeholder="审核状态"
            @change="changeStatus"
          >
            <el-option
              v-for="item in developerAduitList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="6">
        <el-col :span="6">
          <el-row type="flex" align="middle">
            <span style="white-space: nowrap"> 结算周期：</span>
            <el-date-picker
              type="daterange"
              range-separator="至"
              v-model="searchData.date"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-row>
        </el-col>
        <el-col :span="6"
          ><el-button
            type="primary"
            icon="el-icon-search"
            @click="handleSearch()"
            >查询</el-button
          >
          <ExportTable
            v-has="'download'"
            class="ml10"
            @download="getDownloadList"
          ></ExportTable>
        </el-col>
      </el-row>
      <PageTable
        rowKey="releaseId"
        :columns="columns"
        :tableData="tableData"
        @page-change="handleChangePage"
      >
        <template #cycleTime="{ row }">
          <div class="imgsArea">{{ row.startCycle }} - {{ row.endCycle }}</div>
        </template>

        <template #settlementData="{ row }">
          <div class="imgsArea" v-if="row.settlementData">
            <div
              class="file-item"
              v-for="(url, index) in imgChangeType(row.settlementData)"
              :key="index"
            >
              <el-image
                :preview-teleported="true"
                class="image"
                :src="url"
                :preview-src-list="imgChangeType(row.settlementData)"
              >
              </el-image>
            </div>
            <div
              class="file-item"
              v-for="(url, index) in pdfChangeType(row.settlementData)"
              :key="index"
            >
              <img
                @click="lokinfoPDf(url)"
                class="image"
                src="../../../../assets/images/excel.png"
                alt=""
              />
              <!-- 新增的显示文件名的 span -->
              <span class="file-name">{{ getFileName(url) }}</span>
            </div>
          </div>
        </template>
        <template slot-scope="{ row }" slot="status">
          <el-tag
            size="small"
            class="cursor"
            :type="row.status | tagType(developerAduitList)"
            v-if="!row.reviewContent || row.reviewContent == ''"
          >
            {{ row.status | typeDesc(developerAduitList) }}
          </el-tag>
          <el-popover trigger="click" v-else>
            <p
              style="
                max-width: 150px;
                word-wrap: break-word;
                word-break: break-all;
              "
            >
              审核意见：{{ row.reviewContent }}
            </p>
            <el-tag
              size="small"
              class="cursor"
              slot="reference"
              :type="row.status | tagType(developerAduitList)"
            >
              {{ row.status | typeDesc(developerAduitList) }}
            </el-tag>
          </el-popover>
        </template>
        <template slot-scope="{ row }" slot="hasLaunch">
          <div v-if="row.hasLaunch == 1">是</div>
          <div v-else>否</div>
        </template>
        <template slot-scope="{ row }" slot="launchAmount">
          <span v-if="row.hasLaunch == 1">
            {{ row.launchAmount }}
          </span>
        </template>
        <el-table-column
          label="操作"
          width="130px"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button
              class="ml10"
              type="text"
              @click="handleOperate('edit', row)"
            >
              <span>编辑</span>
            </el-button>
          </template>
        </el-table-column>
      </PageTable>
    </div>
    <el-dialog
      center
      destroy-on-close
      :visible.sync="dialogAuditVisible"
      :close-on-click-modal="false"
    >
      <Detail
        :CompanyNameList="CompanyNameList"
        :operationType="operationType"
        :detailData="detailData"
        @submit="handleSubmit"
        @cancel="dialogAuditVisible = false"
      />
    </el-dialog>
    <el-dialog
      :show-close="false"
      center
      :visible.sync="dialogGiveMenoy"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- <el-dialog :show-close="false" center title="该笔充值满足一下激励条件，请确认：" :visible.sync="dialogGiveMenoy" :close-on-click-modal="false" :close-on-press-escape="false"> -->
      <template slot="title">
        <!-- <div class="disfr jsb ac fz15">该笔充值满足以下激励条件，请确认：<div @click="dialogGiveMenoy = false,allMoney=0" class="pointer"><span class="mr10">取消审核</span><i class="el-icon-close"></i></div></div> -->
        <div class="disfr jsb ac fz15">
          该笔充值满足以下激励条件，请确认：
          <div @click="dialogGiveMenoyClose" class="pointer">
            <span class="mr10">取消审核</span><i class="el-icon-close"></i>
          </div>
        </div>
      </template>
      <div class="fc jc">
        <div
          class="mtb20 disfr jc"
          style="margin-bottom: 30px"
          v-if="directAgentList.length > 0"
        >
          <!-- <div style="width:120px;margin: 0px 10px 0 0;" class="disfr jfd">激励类型1：</div> -->
          <el-radio-group v-model="radio">
            <div
              v-for="(item, index) in directAgentList"
              :key="index"
              style="margin: 0 0 10px 0"
            >
              <el-radio
                :label="index"
                @click.native.prevent="changeconfig(index)"
                ><span class="fw6"
                  >{{ item.giveType | typeDesc(incentiveTypeList) }}:</span
                ><span class="p20">
                  满足首充＞＝{{ item.menoy }}，赠送{{
                    item.giveMenoy
                  }}美元推广金</span
                ></el-radio
              >
            </div>
          </el-radio-group>
        </div>
        <div class="mtb20 disfr jc" v-if="giveMenoyList.length > 0">
          <!-- <div style="width:120px;margin: 12px 10px 0 0;" class="disfr jfd">{{directAgentList.length>0?'激励类型2：':'激励类型1：'}}</div> -->
          <el-checkbox-group v-model="checkList" @change="change">
            <div
              v-for="(item, index) in giveMenoyList"
              :key="index"
              style="margin: 0 0 10px 0"
            >
              <!-- <el-checkbox :label="index" ><span class="fw6">{{ item.giveType |  typeDesc(incentiveTypeList)}}:</span><span class="p20">满足{{item.giveType==1?'充值':'新客户首充'}}{{item.menoy}}，{{item.giveType==1?'赠送比例':''}}{{ item.giveType==1?item.pct+'%，':'' }}赠送{{item.giveMenoy}}美元</span></el-checkbox> -->
              <el-checkbox :label="index"
                ><span class="fw6"
                  >{{ item.giveType | typeDesc(incentiveTypeList) }}:</span
                ><span class="p20"
                  >满足{{ item.giveType == 1 ? "充值" : ""
                  }}{{ item.menoy }}，{{ item.giveType == 1 ? "赠送比例" : ""
                  }}{{ item.giveType == 1 ? item.pct + "%，" : "" }}赠送{{
                    item.giveMenoy
                  }}美元</span
                ></el-checkbox
              >
            </div>
          </el-checkbox-group>
        </div>
        <div class="mtb20 disfr jc" v-if="continuousList.length > 0">
          <el-checkbox-group v-model="checkList1" @change="change1">
            <div
              v-for="(item, index) in continuousList"
              :key="index"
              style="margin: 0 0 10px 0"
            >
              <el-checkbox :label="index"
                ><span class="fw6"
                  >{{ item.giveType | typeDesc(incentiveTypeList) }}:</span
                ><span class="p20"
                  >满足{{ item.giveType == 5 ? "续充值" : "新客户首充"
                  }}{{ item.menoy }}，{{ item.giveType == 5 ? "赠送比例" : ""
                  }}{{ item.giveType == 5 ? item.pct + "%，" : "" }}赠送{{
                    item.giveMenoy
                  }}美元</span
                ></el-checkbox
              >
            </div>
          </el-checkbox-group>
        </div>
        <div class="mtb20 disfr jc" v-if="newUserRechargeList.length > 0">
          <el-checkbox-group v-model="checkList2" @change="change2">
            <div
              v-for="(item, index) in newUserRechargeList"
              :key="index"
              style="margin: 0 0 10px 0"
            >
              <el-checkbox :label="index"
                ><span class="fw6"
                  >{{ item.giveType | typeDesc(incentiveTypeList) }}:</span
                ><span class="p20"
                  >满足{{ item.giveType == 6 ? "新客续充值" : "新客首充"
                  }}{{ item.menoy }}，{{ item.moneyType == 1 ? "赠送比例" : ""
                  }}{{ item.moneyType == 1 ? item.pct + "%，" : "" }}赠送{{
                    item.giveMenoy
                  }}美元,上限{{ item.upperLimit }}美元</span
                ></el-checkbox
              >
            </div>
          </el-checkbox-group>
        </div>
        <div class="disfr ac jc mt20">合计赠送金额：{{ allMoney }}美元</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogGiveMenoyBtn(1)">不赠送</el-button>
        <el-button type="primary" @click="dialogGiveMenoyBtn(2)"
          >赠送</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Detail from "./auditModel.vue";
import PageTable from "@/components/PageTableSort";
import {
  developerAduitList,
  MAXSIZE,
  MAXSIZEDOWN,
  incentiveTypeList,
} from "@/common/constant/constant.js";
import {
  auditRecharge,
  getAccountDetailList,
  getAccountDetail,
  getRechargeGive,
  getCheckStatus,
  getAppList,
  getDeveloperUserList,
  editPriceThreshold,
  insertPriceThreshold,
} from "./indexServe";
// import { getDeveloperUserList } from "@/views/business/developer/developerList/indexServe";
import moment from "moment";
import ExportTable from "@/components/ExportTable.vue";
export default {
  name: "taskCheck",
  components: { Detail, ExportTable, PageTable },
  mounted() {
    this.init();
  },
  computed: {
    allMoney() {
      return this.radioMoney + this.checkMoney;
    },
  },
  data() {
    let end = moment(new Date()).format("YYYY-MM-DD");
    let start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    start = moment(start).format("YYYY-MM-DD");
    return {
      operationType: "", // 记录当前操作模式新建-create、编辑-edit
      settlementModellist: [
        {
          label: "CPA",
          value: "CPA",
        },
        {
          label: "CPR",
          value: "CPR",
        },
      ],
      incentiveTypeList,
      dialogGiveMenoy: false, //激励赠送弹框显示与隐藏
      // allMoney:0,
      checkList: [], //勾选的充值赠送
      checkList1: [], //勾选的续充值
      checkList2: [], //勾选的新客充值
      giveMenoyList: [], //满足充值赠送的数组
      directAgentList: [], //满足直客首充和代理首充的数组
      continuousList: [], //满足续充值赠送的数组
      newUserRechargeList: [], //新客户首充，新客户续充值
      // giveMenoyList1:[{giveMenoy:1000,giveType:1,menoy:10000,pct:10},{giveMenoy:2000,giveType:2,menoy:20000,pct:20},{giveMenoy:5000,giveType:1,menoy:50000,pct:50}],
      submitData: {},
      developerAduitList,
      searchData: {
        // date: [start, end],
        date: [],
      },
      companyNameStr: "", //选择的公司名称
      CompanyNameList: [], //所有的公司名称
      tableData: {
        list: [],
      },
      columns: [
        {
          key: "id",
          label: "扣款流水号",
          width: "200px",
          sortable: true,
          fixed: "left",
        },
        {
          key: "settlementModel",
          label: "结算模式",
          width: 200,
        },
        {
          key: "companyName",
          label: "公司名称",
          width: 200,
        },
        {
          key: "appName",
          label: "应用名称",
        },
        {
          slot: "cycleTime",
          label: "结算周期",
          width: 200,
        },
        {
          key: "amount",
          label: "扣款金额($)",
          width: 100,
        },
        {
          slot: "settlementData",
          label: "结算数据",
          width: 120,
        },
        {
          key: "remark",
          label: "备注",
          width: 140,
        },
        {
          key: "creatorName",
          label: "创建人",
        },
        {
          key: "modifyTime",
          label: "修改时间",
          width: 180,
        },
        {
          slot: "status",
          label: "状态",
          width: 140,
        },
        {
          key: "reviewContent",
          label: "审核意见",
        },
      ],
      detailData: {},
      dialogAuditVisible: false,
      reviewList: [1], // 可审核的状态列表
      radio: -1,
      radioMoney: 0, //直客充值 代理充值赠送金额
      checkMoney: 0, //充值赠送金额
      Remark: "",
      effectiveDay: 30,
      incentiveType: null,
      comMoney: 0,
      incentiveRemark: "", //续充值文案
      newUserfirstRemark: "", //新客续充值和新客首充文案
      pullRemark: "", //充值赠送文案
      isCheckincentive: false,
      isCheckiNewUserPull: false, //新客续充 新客户首充选择
      isCheckpull: false,
      appList: [],
    };
  },
  methods: {
    changeTimeDate(e) {
      this.searchData.startTime = e[0];
      this.searchData.endTime = e[1];
    },
    getFileName(url) {
      const arr = url.split("/"); // 按路径分隔，若 url 是纯文件名则可省略，根据实际情况调整
      return arr[arr.length - 1];
    },
    handleOperate(operationType, row) {
      if (["create", "edit"].includes(operationType)) {
        this.dialogAuditVisible = true;
        if (operationType == "cerate") {
          this.detailData = {};
        } else {
          this.detailData = { ...row };
        }
      }
      this.operationType = operationType;
    },
    handleSubmit(formData) {
      console.log(formData, "确定保存的东西");
      const fcn =
        this.operationType === "edit"
          ? editPriceThreshold
          : insertPriceThreshold; // 编辑和新建分别调用不同接口
      fcn(formData).then((res) => {
        if (res && res.code === 0) {
          this.dialogAuditVisible = false;
          this.getTableList({
            page: this.tableData.page,
            size: this.tableData.size,
          }); // 成功后刷新列表
          this.$message.success("操作成功");
        }
      });
    },
    changeStatus(e) {
      if (e == "") {
        this.$set(this.searchData, "status", null);
      }
    },
    changeNameGetapp(e) {
      this.appList = [];
      this.$set(this.searchData, "appName", "");
      this.searchData.appName = null;
      if (e) {
        this.getAppList(e);
      }
    },
    async getAppList(id) {
      let data = {
        id: id,
      };
      const res = await getAppList(data);
      if (res && res.code === 0) {
        this.appList = res.data;
      }
    },
    imgChangeType(arr) {
      let arrayData = [];

      try {
        // 情况1：如果是字符串，尝试解析为JSON数组
        if (typeof arr === "string") {
          // 去除可能存在的前后空格（避免解析失败）
          const trimmedStr = arr.trim();
          // 只有看起来像数组的字符串才尝试解析
          if (trimmedStr.startsWith("[") && trimmedStr.endsWith("]")) {
            arrayData = JSON.parse(trimmedStr);
          } else {
            // 不像数组的字符串，直接包装成数组
            arrayData = [trimmedStr];
          }
        }
        // 情况2：如果已经是数组，直接使用
        else if (Array.isArray(arr)) {
          arrayData = arr;
        }
        // 情况3：其他类型，包装成数组
        else {
          arrayData = [arr];
        }

        // 确保最终是数组（防止解析失败）
        if (!Array.isArray(arrayData)) {
          arrayData = [arr];
        }

        // 筛选xls和xlsx文件
        return arrayData.filter((element) => {
          return (
            typeof element === "string" &&
            (element.endsWith(".jpg") ||
              element.endsWith(".png") ||
              element.endsWith(".jpeg"))
          );
        });
      } catch (e) {
        console.error("解析数据出错:", e);
        return []; // 出错时返回空数组，避免崩溃
      }
    },
    pdfChangeType(arr) {
      let arrayData = [];

      try {
        // 情况1：如果是字符串，尝试解析为JSON数组
        if (typeof arr === "string") {
          // 去除可能存在的前后空格（避免解析失败）
          const trimmedStr = arr.trim();
          // 只有看起来像数组的字符串才尝试解析
          if (trimmedStr.startsWith("[") && trimmedStr.endsWith("]")) {
            arrayData = JSON.parse(trimmedStr);
          } else {
            // 不像数组的字符串，直接包装成数组
            arrayData = [trimmedStr];
          }
        }
        // 情况2：如果已经是数组，直接使用
        else if (Array.isArray(arr)) {
          arrayData = arr;
        }
        // 情况3：其他类型，包装成数组
        else {
          arrayData = [arr];
        }

        // 确保最终是数组（防止解析失败）
        if (!Array.isArray(arrayData)) {
          arrayData = [arr];
        }

        // 筛选xls和xlsx文件
        return arrayData.filter((element) => {
          return (
            typeof element === "string" &&
            (element.endsWith(".xls") || element.endsWith(".xlsx"))
          );
        });
      } catch (e) {
        console.error("解析数据出错:", e);
        return []; // 出错时返回空数组，避免崩溃
      }
      // let arrAy = arr.split(",");
      // if (arr && arr.length > 0) {
      //   return arr.filter((element) =>
      //     element.endsWith(".pdf" || ".xlsx" || ".xls")
      //   );
      // } else {
      //   return "";
      // }
    },
    extractFileName(url) {
      const startIndex = url.lastIndexOf("/") + 1;
      return url.substring(startIndex);
    },
    lokinfoPDf(url) {
      window.open(url, "_blank");
    },
    // 事件监听
    handleChangePage({ page, size }) {
      this.getTableList({ page, size });
    },
    async handleReview(row) {
      this.dialogAuditVisible = true;

      this.detailData = { ...row };
    },
    handleSearch() {
      this.getTableList({ page: 1 });
    },
    async handleSubmitAudit(formData) {
      this.checkList = [];
      this.checkList1 = [];
      this.checkList2 = [];
      const data = { ...formData };
      if (formData.status == 2) {
        // 充值审核通过时，判断是否满足赠送条件
        this.submitData = data;
        this.dialogAuditVisible = false;
        const res1 = await this.getRechargeGive(formData.id);
      } else {
        this.dialogAuditVisible = false;
        auditRecharge(data).then((res) => {
          if (res && res.code === 0) {
            this.dialogAuditVisible = false;
            this.getTableList({
              page: this.tableData.page,
              size: this.tableData.size,
            }); // 成功后刷新列表
            this.$message.success("操作成功");
          }
        });
      }
    },
    async getDownloadList(callback) {
      const res = await this.getTableList({ page: 1, size: MAXSIZEDOWN }, true);
      if (res) {
        const headerDisplay = {};
        this.columns.forEach((item) => {
          const key = item.key || item.slot;
          if (
            key !== "action" &&
            key !== "certificate" &&
            key !== "receiptCertificate"
          ) {
            headerDisplay[key] = item.label;
          }
        });
        // 处理导出的数据
        const list = res.list.map((i) => ({
          ...i,
          status: this.$options.filters["typeDesc"](
            i.status,
            this.developerAduitList
          ),
          hasLaunch: i.hasLaunch == 1 ? "是" : "否",
          launchAmount: i.hasLaunch == 1 ? i.launchAmount : "",
        }));
        callback({
          fileName: "充值审核",
          headerDisplay,
          list,
        });
      }
    },
    // 后端请求
    // 获取列表
    async getTableList(params, isDownload = false) {
      const { date, ...rest } = this.searchData;
      const data = {
        page: 1,
        size: 10,
        ...rest,
        ...params,
      };
      if (date) {
        data.startTime = date[0];
        data.endTime = date[1];
      }
      if (data.companyName === "") {
        delete data.companyName;
      }
      const res = await getAccountDetailList(data);
      if (res && res.code === 0) {
        // this.tableData = res.data;
        // 下载时，不需要更新到table
        if (!isDownload) {
          this.tableData = res.data;
        }
        return res.data;
      }
    },
    // 获取是否满足激励政策
    async getRechargeGive(id) {
      const res = await getRechargeGive({ id });
      if (res.data.length > 0) {
        this.directAgentList = [];
        this.giveMenoyList = [];
        this.continuousList = [];
        this.newUserRechargeList = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].giveType == 3 || res.data[i].giveType == 4) {
            this.directAgentList.push(res.data[i]);
          } else if (res.data[i].giveType == 5) {
            this.continuousList = [res.data[i]];
          } else if (res.data[i].giveType == 6 || res.data[i].giveType == 9) {
            this.newUserRechargeList = [res.data[i]];
          } else {
            this.giveMenoyList = [res.data[i]];
          }
        }
        // console.log(
        //   this.directAgentList,
        //   this.giveMenoyList,
        //   this.continuousList,
        //   this.newUserRechargeList
        // );
        // this.giveMenoyList=res.data
        this.effectiveDay = res.data[0].effectiveDay;
        this.dialogGiveMenoy = true;
      } else {
        auditRecharge(this.submitData).then((res) => {
          if (res && res.code === 0) {
            this.getTableList({
              page: this.tableData.page,
              size: this.tableData.size,
            }); // 成功后刷新列表
            this.$message.success("操作成功");
          }
        });
      }
      // const { menoy, pct, giveMenoy, giveType } = res.data || {};
      // console.log(res.data);
      // let isGive = false;
      // if (menoy > 0) {
      //   let desc;
      //   if (giveType == 1) {
      //     desc = `满足充值${menoy}美元的赠送${pct}%的条件，赠送金额${giveMenoy}美元，确认是否发放?`;
      //   } else {
      //     desc = `满足新客户充值${menoy}美元的赠送${giveMenoy}美元的条件，确认是否发放?`;
      //   }
      //   await this.$confirm(desc, "激励发放确认", {
      //     closeOnClickModal: false,
      //     showClose: false,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //   })
      //     .then(() => {
      //       isGive = true;
      //     })
      //     .catch(() => {
      //       isGive = false;
      //     });
      // }
      // return { isGive, giveAmount: giveMenoy };
      // let obj=await this.dialogGiveMenoyBtn()
      // return obj
    },
    async getCompanyNameList() {
      const res = await getDeveloperUserList({ size: MAXSIZE });
      if (res && res.code === 0 && res.data) {
        const list = (res.data || []).filter(
          (item) => item.companyName != undefined
        );
        this.CompanyNameList = list;
      }
    },
    handleChange(val) {
      this.searchData.companyName = val.split(",")[1];
    },
    // 其他
    init() {
      this.getTableList();
      this.getCompanyNameList();
    },
    dialogGiveMenoyClose() {
      // this.allMoney=0
      this.radio = -1;
      this.radioMoney = 0;
      this.checkMoney = 0;
      this.Remark = "";
      this.pullRemark = "";
      this.incentiveRemark = "";
      this.newUserfirstRemark = "";
      this.dialogGiveMenoy = false;
    },
    dialogGiveMenoyBtn(val) {
      if (val == 1) {
        //取消按钮 2确定按钮
        this.submitData.grant = 2;
        this.submitData.giveMenoy = 0;
      } else {
        if (this.allMoney < 0) {
          this.$message.error("请选择赠送项目");
          return;
        }
        this.submitData.grant = 1;
        this.submitData.giveMenoy = this.allMoney;
      }
      if (this.radio >= 0) {
        let str;
        if (this.directAgentList[this.radio].giveType == 3) {
          str = "直客激励：";
        } else if (this.directAgentList[this.radio].giveType == 5) {
          str = "续充值：";
        } else {
          str = "代理激励：";
        }
        this.submitData.launchRemark =
          this.Remark +
          str +
          "满足首充>=" +
          this.directAgentList[this.radio].menoy +
          "美元，赠送" +
          this.directAgentList[this.radio].giveMenoy +
          "美元推广金";
      } else {
        this.submitData.launchRemark = this.Remark;
      }
      this.submitData.effectiveDay = this.effectiveDay;
      this.submitData.incentiveType = this.incentiveType;
      if (this.isCheckincentive && this.isCheckpull) {
        this.submitData.launchRemark =
          this.submitData.launchRemark + this.incentiveRemark + this.pullRemark;
      } else if (this.isCheckincentive) {
        this.submitData.launchRemark =
          this.submitData.launchRemark + this.incentiveRemark;
      } else if (this.isCheckpull) {
        this.submitData.launchRemark =
          this.submitData.launchRemark + this.pullRemark;
      } else if (this.isCheckiNewUserPull) {
        this.submitData.launchRemark =
          this.submitData.launchRemark + this.newUserfirstRemark;
      }
      console.log(this.submitData);
      // return
      auditRecharge(this.submitData).then((res) => {
        // this.allMoney=0
        this.radio = -1;
        this.radioMoney = 0;
        this.checkMoney = 0;
        this.Remark = "";
        if (res && res.code === 0) {
          this.dialogGiveMenoy = false;
          this.getTableList({
            page: this.tableData.page,
            size: this.tableData.size,
          }); // 成功后刷新列表
          this.$message.success("操作成功");
        }
      });
    },
    change(val) {
      let sum = 0;
      let cause = "";
      for (let i = 0; i < val.length; i++) {
        sum = sum + this.giveMenoyList[val[i]].giveMenoy;
        if (this.giveMenoyList[val[i]].giveType == 1) {
          cause =
            cause +
            `满足充值${this.giveMenoyList[val[i]].menoy},赠送比例：${
              this.giveMenoyList[val[i]].pct
            }%,赠送${this.giveMenoyList[val[i]].giveMenoy}美元;`;
        } else if (this.giveMenoyList[val[i]].giveType == 5) {
          cause =
            cause +
            `满足充值${this.giveMenoyList[val[i]].menoy},赠送比例：${
              this.giveMenoyList[val[i]].pct
            }%,赠送${this.giveMenoyList[val[i]].giveMenoy}美元;`;
        } else {
          cause =
            cause +
            `满足新客户首充${this.giveMenoyList[val[i]].menoy},赠送${
              this.giveMenoyList[val[i]].giveMenoy
            }美元;`;
        }
        this.pullRemark = cause;
      }
      // this.Remark=cause
      // this.checkMoney=sum
      if (val.length > 0) {
        // this.Remark=this.Remark+cause
        this.checkMoney = this.checkMoney + sum;
        this.incentiveType = this.giveMenoyList[0].giveType;
        this.comMoney = this.checkMoney;
        this.isCheckpull = true;
      } else {
        // this.Remark=cause
        this.isCheckpull = false;
        // this.checkMoney = this.comMoney - this.continuousList[0].giveMenoy;
        this.checkMoney = this.comMoney - this.giveMenoyList[0].giveMenoy;
        this.comMoney = this.checkMoney;
        this.pullRemark = "";
        // this.checkMoney=this.checkMoney-sum
        // console.log(this.checkMoney,sum);
      }
      //  this.allMoney=sum
    },
    change1(val) {
      let sum = 0;
      let cause = "";
      for (let i = 0; i < val.length; i++) {
        sum = sum + this.continuousList[val[i]].giveMenoy;
        if (this.continuousList[val[i]].giveType == 1) {
          cause =
            cause +
            `满足续充值${this.continuousList[val[i]].menoy},赠送比例：${
              this.continuousList[val[i]].pct
            }%,赠送${this.continuousList[val[i]].giveMenoy}美元;`;
        } else if (this.continuousList[val[i]].giveType == 5) {
          cause =
            cause +
            `满足续充值${this.continuousList[val[i]].menoy},赠送比例：${
              this.continuousList[val[i]].pct
            }%,赠送${this.continuousList[val[i]].giveMenoy}美元;`;
        } else {
          cause =
            cause +
            `满足新客户首充${this.continuousList[val[i]].menoy},赠送${
              this.continuousList[val[i]].giveMenoy
            }美元;`;
        }
        this.incentiveRemark = cause;
      }
      if (val.length > 0) {
        // this.Remark=this.Remark+cause
        this.checkMoney = this.checkMoney + sum;
        this.incentiveType = this.continuousList[0].giveType;
        this.comMoney = this.checkMoney;
        this.isCheckincentive = true;
      } else {
        // this.Remark=cause
        // this.checkMoney=sum
        // this.Remark=cause
        // console.log(this.checkMoney,this.comMoney);
        this.isCheckincentive = false;
        this.incentiveRemark = "";
        this.checkMoney = this.comMoney - this.continuousList[0].giveMenoy;
        this.comMoney = this.checkMoney;
        // console.log(this.checkMoney,this.comMoney);
      }
    },
    change2(val) {
      let sum = 0;
      let cause = "";
      for (let i = 0; i < val.length; i++) {
        sum = sum + this.newUserRechargeList[val[i]].giveMenoy;
        if (
          this.newUserRechargeList[val[i]].giveType == 6 &&
          this.newUserRechargeList[val[i]].moneyType == 1
        ) {
          cause =
            cause +
            `满足新客续充值${
              this.newUserRechargeList[val[i]].menoy
            },赠送比例：${this.newUserRechargeList[val[i]].pct}%,赠送${
              this.newUserRechargeList[val[i]].giveMenoy
            }美元,上限${this.newUserRechargeList[val[i]].upperLimit}美元;`;
        } else if (
          this.newUserRechargeList[val[i]].giveType == 9 &&
          this.newUserRechargeList[val[i]].moneyType == 1
        ) {
          cause =
            cause +
            `满足新客首充${this.newUserRechargeList[val[i]].menoy},赠送比例：${
              this.newUserRechargeList[val[i]].pct
            }%,赠送${this.newUserRechargeList[val[i]].giveMenoy}美元,上限${
              this.newUserRechargeList[val[i]].upperLimit
            }美元;`;
        } else if (
          this.newUserRechargeList[val[i]].giveType == 6 &&
          this.newUserRechargeList[val[i]].moneyType == 0
        ) {
          cause =
            cause +
            `满足新客续充值${this.newUserRechargeList[val[i]].menoy},赠送${
              this.newUserRechargeList[val[i]].giveMenoy
            }美元,上限${this.newUserRechargeList[val[i]].upperLimit}美元;`;
        } else if (
          this.newUserRechargeList[val[i]].giveType == 9 &&
          this.newUserRechargeList[val[i]].moneyType == 0
        ) {
          cause =
            cause +
            `满足新客首充${this.newUserRechargeList[val[i]].menoy},赠送${
              this.newUserRechargeList[val[i]].giveMenoy
            }美元,上限${this.newUserRechargeList[val[i]].upperLimit}美元;`;
        }
        this.newUserfirstRemark = cause;
      }
      if (val.length > 0) {
        this.checkMoney = this.checkMoney + sum;
        this.incentiveType = this.newUserRechargeList[0].giveType;
        this.comMoney = this.checkMoney;
        this.isCheckiNewUserPull = true;
      } else {
        this.isCheckiNewUserPull = false;
        this.newUserfirstRemark = "";
        this.checkMoney = this.comMoney - this.newUserRechargeList[0].giveMenoy;
        this.comMoney = this.checkMoney;
      }
    },
    changeconfig(val) {
      if (val == this.radio) {
        this.radio = -1;
        this.radioMoney = 0;
        return;
      }
      this.radio = val;
      this.radioMoney = this.directAgentList[val].giveMenoy;
    },
  },
};
</script>
<style scoped lang="scss">
.list-area {
  position: relative;
  .page-foot {
    display: inline-block;
    position: absolute;
    margin-top: -30px;
    div {
      margin-right: 5px;
    }
  }
  .imgsArea {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .image {
      width: 80px;
      flex-shrink: 0;
    }
  }
}
.p20 {
  margin: 10px 20px;
  display: inline-block;
}
.file-item {
  display: inline-block;
  text-align: center;
  margin-right: 10px; /* 可根据需要调整间距 */
}
.file-name {
  display: block; /* 让文字独占一行，在图标下方 */
  margin-top: -15px;
}
// .mr10{
//   margin-right: 10px;
//   display: inline-block;
// }
</style>
